import { createSelector } from 'reselect'
import { getPaginationCurrent } from './algolia'
import { getCollectionTitle, getCollectionTypes } from './collection'
const dataDefaults = {
  collection: '',
  pagetype: 'collection',
  pagination: 1,
  subpagetype: '',
}
export const getDataLayer = createSelector(
  [getCollectionTitle, getCollectionTypes, getPaginationCurrent],
  (collectionTitle, collectionTypes, currentPage) => {
    const data = { ...dataDefaults }
    data.pagination = currentPage + 1 || 1
    data.collection = collectionTitle
    data.subpagetype = collectionTypes
    return data
  }
)